<section class="home-acx-cta" aria-label="Integração ACX Brasil">
  <div class="home-acx-cta__content">
    <span class="home-acx-cta__icon" aria-hidden="true">
      <b3-icon name="sync_alt" size="lg" tone="default"></b3-icon>
    </span>

    <div class="home-acx-cta__text">
      <h2 class="home-acx-cta__title">Integração com ACX Brasil</h2>
      <p class="home-acx-cta__description">
        Negocie seus créditos registrados diretamente no ecossistema global ACX Brasil.
      </p>
    </div>
  </div>

  <b3-button
    type="button"
    variant="filled"
    tone="default"
    (b3-click)="onAccess()">
    Acessar
    <b3-icon name="login" size="md" tone="on-brand"></b3-icon>
  </b3-button>
</section>
